<template>
    <Register type="doctor"/>
</template>

<script>
// @ is an alias to /src
import Register from '@/components/auth/Register'

export default {
  name: 'RegisterDoctor',
  components: {
    Register
  }
}
</script>
